import React from "react"
import widgetService from "live/services/widgets"
import FlatGauge from "./FlatGauge"
import { reactWidgetWrapper } from "live/widgets/decorators/react"
import { reducer } from "./dataReducer"

function Gauge2Widget(
  props: LiveReactChartProps<ChartStateFlatGauge, ChartMessageFlatGauge, Configs>
): JSX.Element {
  return Object.keys(props.state.value).length > 1 &&
    props.state.value.value ? (
    <FlatGauge
      height={props.height}
      width={props.width}
      value={props.state.value.value}
    />
  ) : null
}

widgetService.register({
  get type() {
    return "flat_gauge"
  },
  get name() {
    return "Flat Gauge"
  },
  get description() {
    return "A flat gauge."
  },
  config: {},
  policies: {
    defaultReducer: "@latest",
  },
  // the wrapper is needed to enable the reducer mechanism and comply the API
  impl: reactWidgetWrapper<ChartStateFlatGauge, ChartMessageFlatGauge, Configs>(
    Gauge2Widget,
    reducer
  ),
})
